import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { updateStepData } from '../../Store/Actions/Partner';
import { retrieveAppAddressGooglePlaces,retrieveAppAddressGoogleCoordinates } from '../../Store/Actions/App';

import { useMediaQuery } from 'react-responsive';

import { AutoComplete } from 'primereact/autocomplete';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button'; // 🔥 Adicionado botão

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import {
  maskCep
  } from '../../Components/Utils';


const RegisterStep3 = (props) => {

  const { 
    stepIndex, 
    stepData,
    stepDataAll, 
    updateStepData,
    retrieveAppAddressGooglePlaces, 
    setAlert, 
    setAlertTitle, 
    setAlertBody,
    stepValidations 
  } = props;

  //console.log('stepDataAll STEP 3----------->'+JSON.stringify(stepDataAll,null,2));

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const formDataRef = useRef({});
  const typingTimeoutRef = useRef(null);

  const [formFields, setFormFields] = useState({
    address: stepData?.address || '',
    addressObj: stepData?.addressObj || {},
    latitude: stepData?.latitude || '',
    longitude: stepData?.longitude || '',    
    number: stepData?.number || '',
    complement: stepData?.complement || '',
    neighborhood: stepData?.neighborhood || '',
    city: stepData?.city || '',
    cep: stepData?.cep || '',
    uf: stepData?.uf || '',
    addressSelected: stepData?.addressSelected || false
  });

  const [suggestions, setSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [addressSelected, setAddressSelected] = useState(false);

  const DEBOUNCE_DELAY_MS = 500; // Buffer de espera

  const ufs = [
    { label: 'Selecione', value: '' },
    { label: 'AC', value: 'AC' }, { label: 'AL', value: 'AL' }, { label: 'AP', value: 'AP' },
    { label: 'AM', value: 'AM' }, { label: 'BA', value: 'BA' }, { label: 'CE', value: 'CE' },
    { label: 'DF', value: 'DF' }, { label: 'ES', value: 'ES' }, { label: 'GO', value: 'GO' },
    { label: 'MA', value: 'MA' }, { label: 'MT', value: 'MT' }, { label: 'MS', value: 'MS' },
    { label: 'MG', value: 'MG' }, { label: 'PA', value: 'PA' }, { label: 'PB', value: 'PB' },
    { label: 'PR', value: 'PR' }, { label: 'PE', value: 'PE' }, { label: 'PI', value: 'PI' },
    { label: 'RJ', value: 'RJ' }, { label: 'RN', value: 'RN' }, { label: 'RS', value: 'RS' },
    { label: 'RO', value: 'RO' }, { label: 'RR', value: 'RR' }, { label: 'SC', value: 'SC' },
    { label: 'SP', value: 'SP' }, { label: 'SE', value: 'SE' }, { label: 'TO', value: 'TO' }
  ];

  const handleFieldChange = (fieldName, value) => {
    setFormFields(prev => {
      const updated = { ...prev, [fieldName]: value };
      formDataRef.current = updated;
      return updated;
    });
    formDataRef.current[fieldName] = value;
  };

  const handleBlur = () => {
    updateStepData(stepIndex, { ...formDataRef.current });
  };

  const handleCepChange = (e) => {
    const value = e.target.value || '';
    const maskedValue = maskCep(value);
    handleFieldChange('cep', maskedValue);
  };

  const searchAddress = (event) => {
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
  
    if (!event.query || event.query.length < 3) {
      setSuggestions([]);
      return;
    }
  
    typingTimeoutRef.current = setTimeout(() => {
      setLoadingSuggestions(true);
  
      retrieveAppAddressGooglePlaces({ keyword: event.query }, {
        setItems: (items) => {
          setSuggestions(items);
          setLoadingSuggestions(false);
        },
        setError: (message) => {
          setSuggestions([]);
          setLoadingSuggestions(false);
          if (setAlert && setAlertTitle && setAlertBody) {
            setAlertTitle('Erro ao buscar endereço');
            setAlertBody(message || 'Não conseguimos buscar o endereço. Tente novamente.');
            setAlert(true);
          }
        }
      });
    }, DEBOUNCE_DELAY_MS);
  };

  
  const handleAddressSelect = async (e) => {
    const selected = e.value;
  
    handleFieldChange('address', selected.description || '');
    handleFieldChange('addressObj', selected || {});
  
    if (selected.terms && selected.terms.length > 0) {
      // 🔥 Se vier com número
      if (selected.terms.length >= 6) {
        handleFieldChange('neighborhood', selected.terms[2]?.value || '');
        handleFieldChange('city', selected.terms[3]?.value || '');
        handleFieldChange('uf', selected.terms[4]?.value || '');
  
        // Se termos[1] for um número
        if (selected.terms[1] && selected.terms[1].value && /^\d+$/.test(selected.terms[1].value)) {
          handleFieldChange('number', selected.terms[1].value);
        }
      }
      // 🔥 Se vier sem número (ex: só rua, bairro, cidade, estado)
      else if (selected.terms.length === 5) {
        handleFieldChange('neighborhood', selected.terms[1]?.value || '');
        handleFieldChange('city', selected.terms[2]?.value || '');
        handleFieldChange('uf', selected.terms[3]?.value || '');
        handleFieldChange('number', ''); // número manual
      }
    }
  
    setAddressSelected(true);

    // 🔥 Buscar coordenadas após preenchimento
    await buscarCoordenadasGoogle(selected.description);
  
    // 🔥 Buscar CEP após preenchimento
    await buscarCepViaCep(selected);
  };
  
  
  const buscarCoordenadasGoogle = async (address) => {
    try {
      await props.retrieveAppAddressGoogleCoordinates(
        { address: address },
        {
          onSuccess: (data) => {
            if (data.lat && data.lng) {
              handleFieldChange('latitude', data.lat);
              handleFieldChange('longitude', data.lng);
            }
          },
          onError: (message) => {
            console.error('Erro ao buscar coordenadas:', message);
            // Opcional: Mostrar alerta usando setAlert
          }
        }
      );
    } catch (error) {
      console.error('Erro inesperado ao buscar coordenadas:', error);
    }
  };
  
  
  const buscarCepViaCep = async (selected) => {
    try {
      const estado = encodeURIComponent(selected.terms.length === 5 ? selected.terms[3]?.value || '' : selected.terms[4]?.value || '');
      const cidade = encodeURIComponent(selected.terms.length === 5 ? selected.terms[2]?.value || '' : selected.terms[3]?.value || '');
      const rua = prepararLogradouroParaViaCep(selected.terms[0]?.value || '');
  
      if (!estado || !cidade || !rua) {
        return;
      }
  
      const url = `https://viacep.com.br/ws/${estado}/${cidade}/${rua}/json/`;
      console.log('URL ViaCEP gerada:', url);
  
      const response = await fetch(url);
      const data = await response.json();
  
      if (Array.isArray(data) && data.length > 0 && data[0].cep) {
        handleFieldChange('cep', maskCep(data[0].cep));
      }
    } catch (error) {
      console.error('Erro ao buscar CEP via ViaCEP:', error);
    }
  };
  
  // 🔥 Função auxiliar para preparar o nome da rua
  const prepararLogradouroParaViaCep = (logradouro) => {
    if (!logradouro) return '';
  
    // 1. Remove qualquer coisa depois da primeira vírgula
    let logradouroCortado = logradouro.split(',')[0];
  
    // 2. Remove pontos (.)
    logradouroCortado = logradouroCortado.replace(/\./g, '');
  
    // 3. Se sobrar número isolado no final, remove (opcional)
    logradouroCortado = logradouroCortado.replace(/\s\d+$/, '');
  
    // 4. Encode + troca espaços por +
    return encodeURIComponent(logradouroCortado.trim()).replace(/%20/g, '+');
  };
  
  

  const handleAddressChange = (e) => {
    const value = e.value;
    handleFieldChange('address', value);    

    if (!value) {
      limparCamposEndereco();
    }
  };

  const limparCamposEndereco = () => {
    handleFieldChange('address', '');
    handleFieldChange('addressObj', {});
    handleFieldChange('neighborhood', '');
    handleFieldChange('city', '');
    handleFieldChange('uf', '');
    handleFieldChange('cep', '');
    handleFieldChange('number', '');
    handleFieldChange('complement', '');
    setAddressSelected(false);
    handleFieldChange('addressSelected', false);
  };

//  console.log('formFields ---------------------->'+JSON.stringify(formFields,null,2));

  return (
    <div style={{ width: '100%' }}>
      <Panel header="Endereço do negócio" style={{ marginBottom: "20px", border: "0" }}>
        <Grid container spacing={4} style={{ marginTop: "-20px" }}>

          <Grid item xs={12}>
            <div className="w100 tAlignL formControl" style={{ position: 'relative' }}>
              <label htmlFor="address">Busque o endereço e selecione <span className="requiredField">*</span></label>
              <AutoComplete
                id="address"
                tabIndex={1} 
                value={formFields.address}
                suggestions={suggestions}
                completeMethod={searchAddress}
                field="description"
                onChange={handleAddressChange}
                onSelect={handleAddressSelect}
                onBlur={(e) => { handleBlur(e); }}
                onHide={() => {
                    if (!formFields.addressObj || !formFields.addressObj.description) {
                      handleFieldChange('address', '');
                    }
                }}              
                className="w100"
                inputClassName="w100"
                delay={DEBOUNCE_DELAY_MS}
                minLength={5}               
                placeholder="Comece digitando o endereço"
                disabled={loadingSuggestions}
                readOnly={!!formFields.addressObj?.description}
                forceSelection={true}
                emptyMessage="Nenhum endereço encontrado."
              />
              {formFields.addressObj?.description && (
                <Button
                  icon="pi pi-times"
                  className="p-button-text"
                  style={{ position: 'absolute', transform:"translateY(7px)", right: '9px',backgroundColor:"#FFF",color:"#C53F84", top:isMobile?"-15px":"unset" }}
                  onClick={limparCamposEndereco}
                  tooltip="Limpar endereço"
                  label={isMobile?"Limpar":""}
                  tooltipOptions={{ position: 'left' }}
                />
              )}
              <small className="fLight mL5">Digite o endereço ou parte dele e aguarde as sugestões. Selecione o endereço.</small>
            </div>
          </Grid>

          {/* Restante dos campos iguais ao que você já tinha */}
          <Grid item xs={12} sm={6}>
            <div className="w100 tAlignL formControl">
              <label htmlFor="number">Número</label>
              <InputText
                id="number"
                tabIndex={2} 
                value={formFields.number}
                onChange={(e) => handleFieldChange('number', e.target.value)}
                onBlur={handleBlur}
                className="w100"
                placeholder={!formFields.addressObj?.description ? "Busque o endereço" : "Informe o número, se houver"}
                readOnly={!formFields.addressObj?.description}
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={6}>
            <div className="w100 tAlignL formControl">
              <label htmlFor="complement">Complemento</label>
              <InputText
                id="complement"
                tabIndex={3} 
                value={formFields.complement}
                onChange={(e) => handleFieldChange('complement', e.target.value)}
                onBlur={handleBlur}
                className="w100"
                placeholder={!formFields.addressObj?.description ? "Busque o endereço" : "Informe o complemento, se houver"}
                readOnly={!formFields.addressObj?.description}
              />
            </div>
          </Grid>

          <Grid item xs={12}>
            <div className="w100 tAlignL formControl">
              <label htmlFor="neighborhood">Bairro <span className="requiredField">*</span></label>
              <InputText
                id="neighborhood"
                value={formFields.neighborhood}
                readOnly
                className="w100"
                placeholder="Preenchido automaticamente"
              />
            </div>
          </Grid>

          <Grid item xs={12}>
            <div className="w100 tAlignL formControl">
              <label htmlFor="city">Cidade <span className="requiredField">*</span></label>
              <InputText
                id="city"
                value={formFields.city}
                readOnly
                className="w100"
                placeholder="Preenchido automaticamente"
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={6}>
            <div className="w100 tAlignL formControl">
              <label htmlFor="cep">CEP</label>
              <InputText
                id="cep"
                tabIndex={4} 
                value={formFields.cep}
                onChange={handleCepChange}
                onBlur={handleBlur}
                className="w100"
                placeholder={!formFields.addressObj?.description ? "Busque o endereço" : "Informe o CEP, se souber"}
                readOnly={!formFields.addressObj?.description}
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={6}>
            <div className="w100 tAlignL formControl">
              <label htmlFor="uf">UF <span className="requiredField">*</span></label>
              <Dropdown
                id="uf"
                value={formFields.uf}
                options={ufs}
                readOnly
                className="w100"
                placeholder="Preenchido automaticamente"
              />
            </div>
          </Grid>

        </Grid>
      </Panel>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  stepData: state.partnerReducer.stepData[ownProps.stepIndex],
  stepDataAll: state.partnerReducer.stepData,
});

const mapDispatchToProps = {
  updateStepData,
  retrieveAppAddressGooglePlaces,
  retrieveAppAddressGoogleCoordinates
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterStep3);
